import { useTheme } from '@emotion/react'
import { Container, Grid } from '@mui/material'
import React, { useState } from 'react'
import { Heading, P, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'
import { SocialImage, SocialLinks, SocialMedia } from '../S6_Team/styles'

import Twitter from "../../../assets/images/twitter.png"
import Telegram from "../../../assets/images/telegram.png"
import Medium from "../../../assets/images/medium.png"
import arrow from "../../../assets/images/arrow.png"
import styled from '@emotion/styled'
const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textSecondary)};
color:  #174DFF;
padding: 12px 20px;
border-radius: 5px;
display: flex;
max-width: 160px;
align-items: center;

`
const Div = styled.div`
position: relative;
:after{
    content: '';
  position: absolute;
  top: 0;
  left: 50px;
  right: 50px;
  height: 1px; /* adjust as needed */
  background: linear-gradient(to left, transparent, #000, transparent), /* left-fading gradient */
              linear-gradient(to right, transparent, #000, transparent); /* right-fading gradient */
  background-position: left top, right top;
  background-repeat: no-repeat;
  }
`
const Section9_Footer = () => {

    const theme = useTheme()
    return (
        <Div>
            <SectionWrapper p="4rem 0" style={{backgroundColor:'#174DFF'}}>
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="400"
                            data-aos-duration="500">
                            <SectionSmallHeading color={theme.textSecondary}>
                                Join The Community
                            </SectionSmallHeading>
                            <SocialMedia>
                                <SocialLinks href="#" target="blank"><SocialImage src={Medium} /></SocialLinks>
                                <SocialLinks href="#" target="blank"><SocialImage src={Twitter} /></SocialLinks>
                                <SocialLinks href="#" target="blank"><SocialImage src={Telegram} /></SocialLinks>
                            </SocialMedia>
                        </Grid>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <SectionSmallHeading color={theme.textSecondary}>
                                Quicklinks
                            </SectionSmallHeading>
                            <SocialLinks href="/#home">
                                <P color={theme.textSecondary} p="10px 0" m="0">Home</P>
                            </SocialLinks>
                            <SocialLinks href="/#ecosystem">
                                <P color={theme.textSecondary} p="10px 0" m="0">Our Ecosystem</P>
                            </SocialLinks>
                            <SocialLinks href="/#about">
                                <P color={theme.textSecondary} p="10px 0" m="0">About Token</P>
                            </SocialLinks>
                            <SocialLinks href="/#">
                                <P color={theme.textSecondary} p="10px 0" m="0"> Mixer</P>
                            </SocialLinks>
                            <SocialLinks href="/#">
                                <P color={theme.textSecondary} p="10px 0" m="0"> Our Roadmap</P>
                            </SocialLinks>
                        </Grid>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <SectionSmallHeading color={theme.textSecondary}>
                                Ecosystem
                            </SectionSmallHeading>
                            <SocialLinks href="/#Mix">
                                <P color={theme.textSecondary} p="10px 0" m="0">Mixer</P>
                            </SocialLinks>
                            <SocialLinks href="/#ss">
                                <P color={theme.textSecondary} p="10px 0" m="0">Visa card</P>
                            </SocialLinks>
                            <SocialLinks href="/#rrr">
                                <P color={theme.textSecondary} p="10px 0" m="0">Anon Bridge</P>
                            </SocialLinks>
                            <SocialLinks href="/#">
                                <P color={theme.textSecondary} p="10px 0" m="0"> Staking</P>
                            </SocialLinks>
                            <SocialLinks href="/#">
                                <P color={theme.textSecondary} p="10px 0" m="0"> DAO</P>
                            </SocialLinks>
                        </Grid>
                        <Grid item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">
                            <BuyNow href="/#home"><img src={arrow} />&nbsp;Back To Top</BuyNow>

                        </Grid>
                    </Grid>

                </Container>
            </SectionWrapper>
        </Div>
    )
}

export default Section9_Footer